import * as yup from 'yup'

const schema = yup.object({
  allRelatedCompanies: yup.bool(),
  showHeader: yup.bool(),
  showFooter: yup.bool(),
  pageTitle: yup.string().optional().max(180),
  pageSubtitle: yup.string().optional().max(200),
  primaryColor: yup.string().required().min(4).max(7),
  primaryFontColor: yup.string().required(),
  secondaryColor: yup.string().required().min(4).max(7),
  secondaryFontColor: yup.string().required(),
  applyStamp: yup.bool().required(),
  stampKind: yup.string().when('applyStamp', {
    is: true,
    then: yup.string().required(),
  }),
})

export default schema
